export default "__VITE_ASSET__212ac93f__"